import * as React from 'react'
import styled from 'styled-components'
import Theme from 'ui/theme'

type Props = {
  children?: React.ReactNode
  center?: boolean
  size?: 'xxsmall' | 'xsmall' | 'small' | 'regular' | 'large' | 'xlarge'
  hideOverflow?: boolean
}

const Space = styled.div<Props>`
  > *:not(:first-child) {
    margin-top: ${({ size = 'regular' }: Props) => Theme.spacing[size]};
  }

  ${(props: Props) => props.center && `text-align: center;`}

  ${(props: Props) => props.hideOverflow && `overflow: hidden;`}
`

export default Space
